import { React, useEffect, useState } from "react";
import Facebook from "../../../Assets/Svg/facebook2.svg";
import Instagram from "../../../Assets/Svg/instagram2.svg";
import Telegram from "../../../Assets/Svg/Telegram2.svg";
import Whatsapp from "../../../Assets/Svg/Whatsapp.svg";
import Skype from "../../../Assets/Svg/skype.svg";
import Tiktok from "../../../Assets/Svg/tiktok.svg";
import EditFormInput from "./edit-form-input";
import EditFormSelect from "./edit-form-select";
import EditFormSwitch from "./edit-form-switch";
import { Typography } from "@mui/material";

const EditForm = ({
                    editedProfile,
                    handleInputChange,
                    countries,
                    handleGlobalToggle
                  }) => {
  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    if (countries && countries.length > 0) {
      const options = countries.map((country) => ({
        value: country.id.toString(), // Convert to string to match API response
        label: country.name,
      }));
      setCountryOptions(options);
    }
  }, [countries]);

  // Debug information
  const selectedCountry = countries.find(country =>
      country.id.toString() === editedProfile.country?.toString()
  );
  const selectedCountryName = selectedCountry ? selectedCountry.name : 'Not found';

  return (
      <>
        <div className={'profile-container'}>
          <div className={"edit-form"}>


            <EditFormInput
                showInProfile={true}
                readOnly={true}
                type={"text"}
                isEditing={true}
                label={"User Name"}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"name"}
                inputValue={editedProfile.name}
            />
              <EditFormInput
                  showInProfile={true}
                  readOnly={true}
                  type={"text"}
                  isEditing={true}
                  label={"Email"}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"email"}
                  inputValue={editedProfile.email}
              />
            <EditFormInput
                showInProfile={true}
                readOnly={false}
                type={"text"}
                isEditing={true}
                label={"About"}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"about"}
                inputValue={editedProfile.about}
            />
            <EditFormSelect
                isEditing={true}
                label={"Gender"}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"sex"}
                inputValue={editedProfile.sex}
                options={[
                  { value: "male", label: "Male" },
                  { value: "female", label: "Female" },
                  { value: "other", label: "Other" },
                ]}
            />

            {/* Country Select */}
            <EditFormSelect
                isEditing={true}
                label={"Country"}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"country"}
                inputValue={editedProfile.country}
                options={countryOptions}
            />

            {/* Rest of your form fields */}
            <div className={"social-icon-div"}>
              <EditFormInput
                  showInProfile={false}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Facebook"}
                  icon={Facebook}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"facebook"}
                  inputValue={editedProfile.facebook}
              />
              <EditFormInput
                  showInProfile={false}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Instagram"}
                  icon={Instagram}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"instagram"}
                  inputValue={editedProfile.instagram}
              />
              <EditFormInput
                  showInProfile={false}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Telegram"}
                  icon={Telegram}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"telegram"}
                  inputValue={editedProfile.telegram}
              />
              <EditFormInput
                  showInProfile={false}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Whatsapp"}
                  icon={Whatsapp}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"whatsapp"}
                  inputValue={editedProfile.whatsapp}
                  isPhone={true}
                  countries={countries}
              />
              <EditFormInput
                  showInProfile={false}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Skype"}
                  icon={Skype}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"skype"}
                  inputValue={editedProfile.skype}
              />
              <EditFormInput
                  showInProfile={false}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Tiktok"}
                  icon={Tiktok}
                  editedProfile={editedProfile}
                  handleInputChange={handleInputChange}
                  inputName={"tiktok"}
                  inputValue={editedProfile.tiktok}
              />
            </div>

            <div className={"social-icon-div"}>
              <EditFormSwitch
                  showInProfile={true}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Push Notifications"}
                  editedProfile={editedProfile}
                  handleGlobalToggle={handleGlobalToggle}
                  inputName={"notify_by_push"}
                  inputValue={editedProfile.notify_by_push}
              />
              <EditFormSwitch
                  showInProfile={true}
                  readOnly={false}
                  type={"text"}
                  isEditing={true}
                  label={"Email Notifications"}
                  editedProfile={editedProfile}
                  handleGlobalToggle={handleGlobalToggle}
                  inputName={"notify_by_email"}
                  inputValue={editedProfile.notify_by_email}
              />
            </div>
          </div>
        </div>
      </>
  );
};

export default EditForm;